import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Switch.module.scss';

function Switch({
  activeColor,
  checked,
  className,
  disabled,
  small,
  backgroundClassName,
  ...remainingProps
}) {
  return (
    <div
      className={classNames(
        styles.switch,
        { [styles.checked]: checked },
        { [styles.disabled]: disabled },
        { [styles.default]: !small },
        { [styles.small]: small },
        { [className]: className }
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        {...remainingProps}
      />
      <div className={classNames(styles.track, backgroundClassName)}>
        <div className={styles.thumb} />
      </div>
    </div>
  );
}

Switch.defaultProps = {
  checked: false,
  disabled: false,
};

Switch.propTypes = {
  activeColor: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  small: PropTypes.bool,
};

export default Switch;
